import XMark from '../../src/legacy/XMark';
export default XMark;
